// extracted by mini-css-extract-plugin
export default {"billing-invoices-upload-button":"billing-invoices-upload-button_T4w75"};